import React, { useEffect, useState } from 'react';
import styles from './styles.module.scss';
import moment from 'moment';
import cn from 'classnames';
import Text from '../../../../../components/Basic/WrapsStyle/Text';

const IncreasedCommissionTimerBlock = ({ date, order_id, only_hours = false, ...props }) => {
  const days_7_milisecond = 7 * 24 * 60 * 60 * 1000;
  const days_1_milisecond = 1 * 24 * 60 * 60 * 1000;

  const [isExpired, setExpired] = useState(false);
  const [time, setTime] = useState({ hours: 0, minutes: 0 });

  const calcDate = (d) => {
    const start = moment(d);
    const now = moment();
    let milisecond = now.diff(start);

    if (milisecond) {
      if (milisecond < days_7_milisecond - days_1_milisecond) {
        setExpired(false);
        milisecond = days_7_milisecond - milisecond; //чтобы увидеть время сколько осталось
        let minutes = milisecond / (60 * 1000);
        const hours = (minutes / 60).toFixed(0);
        minutes = (minutes % 60).toFixed(0);
        setTime({ hours, minutes });
      } else {
        setExpired(true);
        //milisecond -= days_7_milisecond; //чтобы увидеть время сколько осталось

        milisecond = days_7_milisecond - milisecond; //чтобы увидеть время сколько осталось

        let minutes = milisecond / (60 * 1000);
        const hours = (minutes / 60).toFixed(0);
        minutes = (minutes % 60).toFixed(0);
        setTime({ hours, minutes });
      }
    }
  };

  useEffect(() => {
    if (date) {
      calcDate(date);
    }
  }, [date]);

  return only_hours ? (
    <>
      {time.hours < 48 && (
        <Text className={cn(styles.time, isExpired ? styles.red : styles.green)}>{`${time.hours} ч.`}</Text>
      )}
    </>
  ) : (
    <Text className={cn(styles.time, isExpired ? styles.red : styles.green)}>
      {`${time.hours} ч. ${time.minutes} мин.`}
    </Text>
  );
};

export default IncreasedCommissionTimerBlock;
